(function () {

  'use strict';

  angular.module('Applications')
    .controller('ApplicationsController', function (
      $scope, EventHandlerService, currentTenant, $routeParams, $location, $rootScope) {

      $scope.helpCaption = 'HelpApplicationsPage';
      $scope.tenant = currentTenant;
      $scope.me = null;
      $scope.eventHandlerService = EventHandlerService;
      $scope.error = null;

      $scope.$watch(function () {
        return $rootScope.currentUser;
      }, function () {
        if ($rootScope.currentUser) {
          $scope.me = $rootScope.currentUser;
        }
      });

      (function () {
        initTab();
        initEventHandler();
      })();

      function initTab() {
        if ($routeParams['applicationsSection']) {
          $scope.showSection = $routeParams['applicationsSection'];
        } else {
          $scope.showSection = 'applications';
        }
      }

      $scope.changeSection = function (section) {
        $scope.showSection = section;
        const url = $location.path();
        $location.path(url, false).search({ applicationsSection: section });
      };

      $scope.$on('REQUEST_ERROR_HELP', (name, data) => {
        $scope.error = data.error;
      });

      $scope.clearError = () => {
        $scope.error = null;
      };

      function initEventHandler() {
        $scope.eventHandlerService.deRegisterListeners();
      };

    });
})();
